﻿enum ReservationType {
	Undefined,
	Business
}

export default ReservationType;
